module.exports = __webpack_public_path__ + "static/media/congrats@2x.46ac0be1.png";